const EXECUTIVE_SUMMARY = '/executive-summary/:projectId/:step';
const APPLICATION = '/program/:id/application';
const PROFILE = '/profile';
const MY_PROGRAM_MATCHING = '/program/:id/matching';
const MY_VENTURE = '/venture/:id/workspace';
const VENTURE_SUMMARY = '/venture/:projectId/venture-summary';
const SETTINGS = '/settings';
const MANAGEMENT_PANEL_PROJECT = '/program-management/:organizationId/:programId/projects';
const MENTOR_MATCHING = '/mentor-matching/:id/*';
const COMMUNITY = '/community';
const COMMUNITY_SETTINGS = '/community/:profileId/settings';
const COMMUNITY_PROFILE = '/community/:profileId';
const TOOLS = '/tools/:projectId/:slug/*';
const LOGIN = '/login';
const SIGNUP = '/signup';
const VERIFY_EMAIL = '/verify-email';
const VERIFY_EMAIL_TOKEN = '/verify-email/:token';
const ROOT = '/';
const ROOT_ADMIN = '/admin-dashboard';
const RESET_PASSWORD = '/reset-password';

export {
  APPLICATION,
  EXECUTIVE_SUMMARY,
  MANAGEMENT_PANEL_PROJECT,
  MY_PROGRAM_MATCHING,
  MY_VENTURE,
  VENTURE_SUMMARY,
  PROFILE,
  SETTINGS,
  COMMUNITY,
  COMMUNITY_SETTINGS,
  COMMUNITY_PROFILE,
  MENTOR_MATCHING,
  TOOLS,
  LOGIN,
  SIGNUP,
  VERIFY_EMAIL,
  VERIFY_EMAIL_TOKEN,
  ROOT,
  ROOT_ADMIN,
  RESET_PASSWORD,
};
